import { HttpErrorResponse } from '@angular/common/http';
import { Component, inject } from '@angular/core';
import { NxLabelModule } from '@aposin/ng-aquila/base';
import { NxButtonModule } from '@aposin/ng-aquila/button';
import { NxHeadlineModule } from '@aposin/ng-aquila/headline';
import { NxIconModule } from '@aposin/ng-aquila/icon';
import { NX_MODAL_DATA, NxDialogService, NxModalRef } from '@aposin/ng-aquila/modal';
import { NxSpinnerModule } from '@aposin/ng-aquila/spinner';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  template: `<div data-testid="error-modal">
    <div class="flex justify-center mb-3.5">
      <nx-icon style="color: var(--danger)" name="exclamation-circle-o" aria-hidden="true" size="l" />
    </div>
    <h3 class="text-center" nxHeadline size="m">{{ 'error.title' | translate }}</h3>
    <nx-label class="nx-margin-s text-center">
      {{ 'error.modal.text' | translate }}
    </nx-label>
    @if (errorTraceparent) {
      <span class="italic">{{ 'error.traceparent' | translate: { traceparent: errorTraceparent } }}</span>
    }
    <div class="flex justify-center mt-7">
      <button (click)="submit()" nxButton="small-medium" type="button">
        {{ 'error.modal.button' | translate }}
      </button>
    </div>
  </div>`,
  imports: [NxHeadlineModule, NxButtonModule, NxIconModule, NxSpinnerModule, NxLabelModule, TranslateModule],
})
export class ErrorModalComponent {
  readonly data = inject<{
    closeModal: () => void;
    error: unknown;
  }>(NX_MODAL_DATA);

  errorTraceparent?: string;

  constructor() {
    const data = this.data;

    if (data.error instanceof HttpErrorResponse) {
      this.errorTraceparent = data.error.headers.get('traceparent') ?? undefined;
    }
  }

  async submit() {
    this.data.closeModal();
  }
}

export function displayError({
  dialogService,
  err,
  modalsToClose = [],
}: {
  dialogService: NxDialogService;
  err: unknown;
  modalsToClose?: (NxModalRef<unknown, unknown> | undefined)[];
}) {
  console.error(err);
  modalsToClose?.forEach((modal) => modal?.close());
  const dialogRef = dialogService.open(ErrorModalComponent, {
    showCloseIcon: true,
    data: { closeModal: () => dialogRef?.close(), error: err },
  });
}
